import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PlatformLogin from "../pages/platform/Login";
import PlatformDashboard from "../pages/platform/Dashboard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/platform/login",
    element: <PlatformLogin />,
  },
  {
    path: "/platform/dashboard",
    element: <PlatformDashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
